


function toast(self,text, type, time, option) {
  const toast = self.$createToast({
    time: time || 1000,
    type: type || "correct",
    txt: text || "成功"
  });
  toast.show();
}
export { toast };
